<template>
    <RegulatedProductStatementDeclaration
        border-variant="light"
        selection-mode="radio"
        show-comment
        :properties="rows"
        @change="change"
    />
</template>

<script>
// Retained for callers of GeneralInfo outside ProductCardV5, including the legacy
// received-request product-card flow. Do not use this catalog merge for new cards.
import { ProductApi } from '@core/api'
import RegulatedProductStatementDeclaration from '@core/components/product/RegulatedProductStatementDeclaration.vue'

export default {
    components: { RegulatedProductStatementDeclaration },
    props: { product: { type: Object, required: true } },
    data() {
        return { statements: [], loaded: false, rows: [] }
    },
    created() {
        ProductApi.getAllGeneralProductStatements().then(response => {
            this.statements = response.data
            this.loaded = true
            this.recalculate()
        })
    },
    watch: {
        product() { this.recalculate() },
    },
    methods: {
        change(rows) {
            this.rows = rows
            this.product.regulatedProductStatements = rows
        },
        recalculate() {
            if (!this.loaded || !this.product.id || !Array.isArray(this.product.regulatedProductStatements)) return
            const values = {}
            this.product.regulatedProductStatements.forEach(row => {
                const id = row.statement && row.statement.id ? row.statement.id : row.statement
                if (id) values[id] = row
            })
            this.rows = this.statements.map(statement => {
                const value = values[statement.id]
                return {
                    statement: { id: statement.id, title: statement.productStatement },
                    coveredExcluded: value ? value.coveredExcluded : null,
                    comment: value && Object.prototype.hasOwnProperty.call(value, 'comment') ? value.comment : null,
                }
            })
        },
    },
}
</script>
